module.exports = __webpack_public_path__ + "img/f01.13fed06e.webp";